/**
 * Created by zad on 17/9/28.
 */
import React from 'react';
import getComponentName from '../utils/getComponentName';

export default getComponent => class AsyncRoute extends React.Component {
  static Component = null;
  static displayName = 'AsyncRoute()';

  constructor(props) {
    super(props);
    this.state = { 
      Component: AsyncRoute.Component,
      error: null
    };
  }

  componentDidMount() {
    if (!this.state.Component) {
      getComponent()
        .then((module) => {
          // 确保模块和默认导出都存在
          if (module && module.default) {
            AsyncRoute.Component = module.default;
            AsyncRoute.displayName = `AsyncRoute(${getComponentName(module.default)})`;
            this.setState({
              Component: module.default,
              error: null
            });
          } else {
            // 如果模块导入失败，设置一个错误组件
            console.error('Failed to load component:', module);
            this.setState({
              Component: null,
              error: new Error('Failed to load component')
            });
          }
        })
        .catch(error => {
          // 捕获导入错误
          console.error('Error importing component:', error);
          this.setState({
            Component: null,
            error
          });
        });
    }
  }

  render() {
    const { Component, error } = this.state;
    
    // 如果有错误，显示错误信息
    if (error) {
      console.error('AsyncRoute error:', error);
      return <div>Error loading component: {error.message}</div>;
    }
    
    // 确保返回有效的React元素
    if (Component) {
      try {
        return <Component {...this.props}/>;
      } catch (renderError) {
        console.error('Error rendering component:', renderError);
        return <div>Error rendering component: {renderError.message}</div>;
      }
    }
    
    // 加载状态
    return <div>Loading...</div>;
  }
};


// WEBPACK FOOTER //
// ./src/HOC/AsyncRoute.js